import { Descriptions } from 'antd'

import { SWMSGeneralInfoDisplayBlock } from '../../types/blueprint'

import PreventPageBreak from '@/components/shared-components/PrintMedia'
import { useLocale } from '@/context/localeContext'

type Props = {
  block: SWMSGeneralInfoDisplayBlock
}

export const SwmsGeneralInfoDisplayBlock: React.FC<Props> = ({ block }) => {
  const { t } = useLocale()
  return (
    <>
      <PreventPageBreak shouldAvoidPageBreak>
        <Descriptions bordered column={{ xs: 1, md: 2 }} size="small">
          <Descriptions.Item
            label={t('swmsBuilder:labels.generalInfo.builder')}
            span={2}
          >
            {block.builderName}
          </Descriptions.Item>

          <Descriptions.Item
            label={t('swmsBuilder:labels.generalInfo.project')}
          >
            {block.projectName}
          </Descriptions.Item>

          <Descriptions.Item
            label={t('swmsBuilder:labels.generalInfo.siteAddress')}
          >
            {block.projectAddress}
          </Descriptions.Item>

          <Descriptions.Item label={block.builderContactPosition}>
            {block.builderContactName}
          </Descriptions.Item>

          <Descriptions.Item
            label={t('swmsBuilder:labels.generalInfo.contact')}
          >
            {block.builderContactPhone}
          </Descriptions.Item>
        </Descriptions>
      </PreventPageBreak>

      <br />

      <PreventPageBreak shouldAvoidPageBreak>
        <Descriptions bordered column={{ xs: 1, md: 2 }} size="small">
          <Descriptions.Item
            label={t('swmsBuilder:labels.generalInfo.subcontractorName')}
          >
            {block.subcontractorName}
          </Descriptions.Item>

          <Descriptions.Item label={t('swmsBuilder:labels.generalInfo.abn')}>
            {block.subcontractorABN}
          </Descriptions.Item>

          {!!block.worksOverview && (
            <Descriptions.Item
              label={t('swmsBuilder:labels.generalInfo.worksOverview')}
            >
              {block.worksOverview}
            </Descriptions.Item>
          )}
        </Descriptions>
      </PreventPageBreak>
    </>
  )
}
